// extracted by mini-css-extract-plugin
module.exports = {"banner":"LegalFooter-module--banner--389on"};